


export const normalize = (str) =>
    str
      .toLowerCase()
      .normalize("NFD") // décompose les lettres accentuées
      .replace(/[\u0300-\u036f]/g, "") // supprime les accents
      .replace(/[\/\\]/g, "") // supprime / et \
      .replace(/\s+/g, " ") // normalise les espaces
      .trim();
  